'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { Button } from './ui/button';

export default function Footer() {
  const pathname = usePathname();

  // Don't show footer on auth pages
  if (pathname === '/auth/signin') {
    return null;
  }

  const handleShowCookiePreferences = () => {
    // Get the current consent
    const consent = localStorage.getItem('cookieConsent')
    const parsedConsent = consent ? JSON.parse(consent) : { necessary: true, statistics: true }
    
    // Update localStorage with current settings to ensure CookieBanner reads the latest state
    localStorage.setItem('cookieConsent', JSON.stringify(parsedConsent))
    
    // Remove the consent to trigger banner display
    localStorage.removeItem('cookieConsent')
    
    // Force a page reload to show the banner
    window.location.reload()
  }

  return (
    <footer className="bg-white border-t mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h3 className="text-lg font-semibold text-gray-900 mb-4">About Ripli</h3>
            <p className="text-gray-600 mb-4">
              The AI-powered, cross channel social media management platform
            </p>
            <p>
                <Button 
                  variant="link" 
                  className="text-gray-600 hover:text-gray-900 p-0 h-auto font-normal"
                  onClick={handleShowCookiePreferences}
                >
                  Cookie Preferences
                </Button>
              </p>
          </div>
          <div>
            <h3 className="text-lg font-semibold text-gray-900 mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link href="/pricing" className="text-gray-600 hover:text-gray-900">
                  Pricing
                </Link>
              </li>
              <li>
                <Link href="/features" className="text-gray-600 hover:text-gray-900">
                  Features
                </Link>
              </li>
              <li>
                <Link href="/support" className="text-gray-600 hover:text-gray-900">
                  Support
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h3 className="text-lg font-semibold text-gray-900 mb-4">Legal</h3>
            <ul className="space-y-2">
              <li>
                <Link href="/legal-notice" className="text-gray-600 hover:text-gray-900">
                  Legal Notice
                </Link>
              </li>
              <li>
                <Link href="/privacy" className="text-gray-600 hover:text-gray-900">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link href="/terms" className="text-gray-600 hover:text-gray-900">
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-8 pt-8 border-t text-center text-gray-500">
          <p>© {new Date().getFullYear()} Ripli. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
